var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import ContentLayout from "../../../Layout/ContentLayout";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import DateService from "../../../../Services/Shared/Date.service";
import { InlineFormFormat } from "../../../UI/FormFormat/FormFormat";
import TextField from "../../../Form/TextField";
import PageTitle from "../../../UI/PageTitle/PageTitle";
import NumberService from "../../../../Services/Shared/Number.service";
import DateRangeField from "../../../Form/DateRangeField";
import LmsImportErrorService from "../../../../Services/LmsImportError.service";
import { getLmsImportErrorDetailPath } from "./LmsImportErrorRoutes";
const PAGE_SIZE = 50;
const LmsImportErrorListTable = () => {
    var _a, _b;
    const [searchArgs, setSearchArgs] = React.useState({});
    const { table, dataState } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No enrollment import errors found",
        rowVerticalPadding: 2,
        searchArgs,
        getData: (sort, pageNumber, sArgs) => {
            return LmsImportErrorService.search({
                enrollmentDataQuery: sArgs.enrollmentDataQuery,
                messageQuery: sArgs.messageQuery,
                createdDateFrom: sArgs.createdDateFrom,
                createdDateTo: sArgs.createdDateTo,
            }, {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "ID",
                sortId: "LMS_IMPORT_ERROR_ID",
            },
            {
                title: "Student LMS ID",
                sortId: "LMS_IMPORT_ERROR_STUDENT_LMS_ID",
            },
            {
                title: "Student Username",
                sortId: "LMS_IMPORT_ERROR_STUDENT_USERNAME",
            },
            {
                title: "Course Section Id",
                sortId: "LMS_IMPORT_ERROR_COURSE_SECTION_ID",
            },
            {
                title: "Course Section SIS ID",
                sortId: "LMS_IMPORT_ERROR_COURSE_SECTION_SIS_ID",
            },
            {
                title: "Current Grade",
                sortId: "LMS_IMPORT_ERROR_CURRENT_GRADE",
            },
            {
                title: "Message",
                sortId: "LMS_IMPORT_ERROR_MESSAGE",
            },
            {
                title: "Created Date",
                sortId: "LMS_IMPORT_ERROR_CREATED_DATE",
            },
        ],
        rows: ({ data }) => data.map((row, index) => {
            return [
                _jsx(Link, { to: getLmsImportErrorDetailPath(row.id), children: row.id }, index),
                row.studentLmsId,
                row.studentUsername,
                row.courseSectionId,
                row.courseSectionSisId,
                row.currentGrade,
                row.message,
                DateService.displayLongWithTimeWithoutWeekday(row.dateCreated),
            ];
        }),
    });
    return (_jsxs(_Fragment, { children: [_jsxs(PageTitle, { className: "mb-3", children: ["Enrollment Import Errors", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total)
                        ? `(${NumberService.format((_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total)})`
                        : ""] }), _jsx("div", { className: "text-muted mb-2", children: "Shows a list of Enrollments from the Lms that could not be imported into SS&E, and why. This report is regenerated each time the Enrollment Import runs." }), _jsx("div", { className: "mb-3", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                        var _c, _d;
                        setSearchArgs({
                            enrollmentDataQuery: formState.enrollmentDataQuery,
                            messageQuery: formState.messageQuery,
                            createdDateFrom: (_c = formState.createdDateFrom) === null || _c === void 0 ? void 0 : _c.toDate(),
                            createdDateTo: (_d = formState.createdDateTo) === null || _d === void 0 ? void 0 : _d.toDate(),
                        });
                    }), children: [_jsx(TextField, { name: "enrollmentDataQuery", label: "Search enrollment data" }), _jsx(TextField, { name: "messageQuery", label: "Search message" }), _jsx(DateRangeField, { nameStart: "createdDateFrom", nameEnd: "createdDateTo", placeHolderStart: "Created Date From", placeHolderEnd: "Created Date To" })] }) }), _jsx("div", { className: "py-2", children: table })] }));
};
const LmsImportErrorList = () => {
    return (_jsx(ContentLayout, { whiteBackground: true, paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(LmsImportErrorListTable, {}) }));
};
export default LmsImportErrorList;
